// Module-level holders for the auth getters per docs/ui/auth0-frontend-tds.md §6.3.
// Mirrors apps/admin-ui/src/auth/token-holder.ts.
//
// Code outside the React tree (the configured ky instance, Socket.IO client,
// idle monitor, force-logout) needs to read tokens and trigger logout, but cannot
// call useAuth0() — they're not React components. AuthBridge (mounted inside the
// Auth0Provider) injects the live functions here, and modules import the getter
// without depending on React.

type TokenGetter = () => Promise<string>;
type Auth0Logout = (opts: { logoutParams: { returnTo: string } }) => Promise<void>;

let tokenGetter: TokenGetter | null = null;
let auth0Logout: Auth0Logout | null = null;

export function setTokenGetter(g: TokenGetter | null): void {
  tokenGetter = g;
}

export function setAuth0Logout(fn: Auth0Logout | null): void {
  auth0Logout = fn;
}

export async function getAccessToken(): Promise<string> {
  if (!tokenGetter) {
    throw new Error(
      'Token getter not initialised. AuthBridge must be mounted inside Auth0Provider.',
    );
  }
  return tokenGetter();
}

export function getAuth0Logout(): Auth0Logout | null {
  return auth0Logout;
}
